import React from "react";
import s from './Header.module.css';
import {NavLink} from "react-router-dom";
import {  FiUsers } from "react-icons/fi";

const Header = (props) => {
    const { name, logout, isAuth} = props
    return (
        <header className={s.headerWrapper}>
            <div className ={s.header}>
                <NavLink to='/adv' >
                    <img src='https://vk.com/images/svg_icons/ic_head_logo.svg'/>
                </NavLink>
                    {isAuth
                        ?
                        <div className={s.headerBlock}>
                            <div className={s.headerItem}>
                                Кризис и рынок
                            </div>
                            <div className={s.headerItem}>
                                Аналитика для бизнеса
                            </div>
                            <div className={s.headerItem}>
                                Каталог специалистов
                            </div>
                            <div className={s.headerItem}>
                                Поиск по карте
                            </div>
                            <div className={s.headerItem}>
                                Вопросы риэлтору
                            </div>
                            <div className={s.headerItem}>
                                <NavLink to='/my' >  {`${name}   Личный кабинет`}  </NavLink>
                            </div>
                            <div className={s.headerItem} onClick={logout}>
                                <NavLink to='/my' > Выйти  </NavLink>
                            </div>
                        </div>

                        : <div className={s.headerItem}>
                            <NavLink to={'/login'}><FiUsers/> вход и регистрация</NavLink>
                        </div>}
                </div>

        </header>
    )
}

export default Header;